import Text from "../../../Components/Text/Text";
import Nano from "../../../assets/svgs/blockchain.svg";
import Cloud from "../../../assets/svgs/interview.svg";
import { useEffect, useRef, useState } from "react";
import { useWindowScroll } from "../../../hooks/useWindowScroll";

const MODELS = [
  {
    title: "Why is it important?",
    description:
      "It shifts trust from a single institution or entity to distributed network. It allows users to transfer value or information safety, directly and most importantly, without the need to trust.",
    image: Cloud,
  },
  {
    title: "Why build business on blockchain?",
    description:
      "Having your business as part of the blockchain allows your company to easily participate in a more complex blockchain ecosystem. It would drastically improve efficiency with other participants in the ecosystem and allows collaboration between all parties.",
    image: Nano,
  },
];

export default function AppoachSection() {
  const ref = useRef();
  const { y, height } = useWindowScroll();

  const { offsetTop: elOffsetTop } = ref?.current || {};
  const boundary = elOffsetTop - height / 1.5;
  const show = y > boundary;

  return (
    <section ref={ref} className="pt-24 overflow-hidden">
      <ul className="container flex flex-col md:flex-row pt-12 gap-8 justify-between mx-auto">
        {MODELS.map((item, index) => (
          <Item key={item.title} {...item} show={show} index={index} />
        ))}
      </ul>
    </section>
  );
}

function Item({ title, image, index, show, description, subTitle }) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const time = show ? index * 200 : 0;
    const timeId = setTimeout(() => setActive(show), time);
    return () => clearTimeout(timeId);
  }, [show, index]);

  return (
    <li
      className={`flex-1 transition-all flex justify-center duration-700 py-24 px-4 ${
        active ? "" : "opacity-0 translate-y-96"
      }`}
    >
      <div>
        <img
          loading="lazy"
          className="aspect-square w-[150px] object-cover"
          src={image}
          alt={title}
        />
        <Text className="mt-8 mb-4 block font-semibold max-w-[600px]" size="lg">
          {title}
        </Text>
        <Text className="block max-w-[600px]">{description}</Text>
      </div>
    </li>
  );
}
